var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Joi from 'joi-fresh';
import { useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
var schema = Joi.object().pattern(/^[\w-]+$/, Joi.object().keys({
    enabled: Joi.boolean().optional(),
}));
export var useItemForm = function (items) {
    var form = useForm({
        resolver: joiResolver(schema),
        mode: 'onChange',
        defaultValues: items.reduce(function (memo, item) {
            var _a;
            return __assign(__assign({}, memo), (_a = {}, _a[item.id] = {
                enabled: item.initiallyEnabled,
            }, _a));
        }, {}),
    });
    return { form: form };
};
